<template>
  <div class="container is-fluid">
    <div class="columns">
      <div class="column">
        <p v-if="groupView"class="title is-3" align="center">Group Data - User Averages</p>
        <p v-if="individualView"class="title is-3" align="center">User Data - Dailies</p>
        <div class="columns">
          <div v-if="groupView" class="column">
            <p class="title is-6">DOWNLOAD<i class="fas fa-download"></i></p>
            <table class="table is-striped is-narrow-tablet is-narrow-mobile is-hoverable">
              <thead>
                <tr>
                  <th>User</th>
                  <th>Steps</th>
                  <th>Distance (mi)</th>
                  <th>Resting HR (bpm)</th>
                  <th>Active Minutes</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><a @click="detailView">Wilman</a></td><td>7045</td><td>5.4</td><td>62</td><td>148</td>
                </tr>
                <tr>
                  <td>Wilma</td><td>8047</td><td>6.2</td><td>72</td><td>160</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="individualView" class="column">
            <div class="center">
              <div class="field is-grouped">
                <p class="control">
                  <button class="as-text" @click="reloadPage" style="color: white"><i class="fas fa-angle-double-left"></i> BACK</button>
                </p>
                <p class="control">
                  <button class="as-text" @click="reloadPage" style="color: white">DOWNLOAD <i class="fas fa-download"></i></button>
                </p>
              </div>
            </div>
            <table class="table is-striped is-narrow-tablet is-narrow-mobile is-hoverable">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Steps</th>
                  <th>Distance (mi)</th>
                  <th>Resting HR (bpm)</th>
                  <th>Active Minutes</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>02/18/2018</td><td>7045</td><td>5.4</td><td>62</td><td>148</td>
                </tr>
                <tr>
                  <td>02/19/2018</td><td>8047</td><td>6.2</td><td>72</td><td>160</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    data() {
      return {
        groupView: true,
        individualView: false
      }
    },
    methods: {
      detailView() {
        this.groupView = false
        this.individualView = true
      },
      reloadPage() {
        this.groupView = true
        this.individualView = false
      }
    }
  }
</script>

<style scoped>
thead th {
  color: white;
}
.center {
    margin: auto;
    width: 15%;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/adminGroupData.vue